import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';

import {
  EquipamentoFilterStateService,
  EquipamentoFilters,
} from '../../services/equipamento-filter-state.service';
import { EnumService } from '@shared/api/services/enum.service';
import { TipoEquipService } from '@core/services/domain-services';
import { PostoService } from '@shared/api/services/posto.service';

@Component({
  selector: 'app-equipamento-filter-drawer',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    DatePickerModule,
  ],
  templateUrl: './equipamento-filter-drawer.component.html',
  styleUrl: './equipamento-filter-drawer.component.scss',
})
export class EquipamentoFilterDrawerComponent implements OnInit {
  @Input() visible = false;
  @Output() close = new EventEmitter<void>();
  @Output() applyFilter = new EventEmitter<EquipamentoFilters>();

  private readonly filterSvc = inject(EquipamentoFilterStateService);
  private readonly enumService = inject(EnumService);
  private readonly tipoEqService = inject(TipoEquipService);
  private readonly postoService = inject(PostoService);

  filtrosForm = new FormGroup({
    Estado: new FormControl<string | null>(null),
    Ativo: new FormControl<boolean | null>(null),
    IdPosto: new FormControl<number | null>(null),
    DataAquisicao: new FormControl<Date | null>(null),
    Search: new FormControl<string | null>(null),
    IdTipoEquipamento: new FormControl<number | null>(null),
    TipoEquipamentoEnum: new FormControl<string | null>({ value: null, disabled: true }),
  });

  estadoOptions: any[] = [];
  postoOptions: { label: string; value: number | string }[] = [];

  readonly tiposArmas = [
    { label: 'Pistola', value: 'PISTOLA' },
    { label: 'Revólver', value: 'REVOLVER' },
    { label: 'Espingarda', value: 'ESPINGARDA' },
    { label: 'Carabina', value: 'CARABINA' },
    { label: 'AK-47', value: 'AK_47' },
    { label: 'Rifle / Fuzil', value: 'FUZIL' },
    { label: 'Submetralhadora', value: 'SUBMETRALHADORA' },
    { label: 'Metralhadora', value: 'METRALHADORA' },
    { label: 'Outra Arma', value: 'OUTRO' },
  ];

  readonly tiposViaturas = [
    { label: 'Viatura', value: 'VIATURA' },
    { label: 'Motocicleta', value: 'MOTOCICLETA' },
    { label: 'Bicicleta', value: 'BICICLETA' },
    { label: 'Quadriciclo', value: 'QUADRICICLO' },
    { label: 'Outra Viatura', value: 'OUTRO' },
  ];

  readonly tiposUtensilios = [
    { label: 'Lanterna', value: 'LANTERNA' },
    { label: 'Rádio Comunicador', value: 'RADIO_COMUNICADOR' },
    { label: 'Colete Balístico / Reflector', value: 'COLETE_BALISTICO' },
    { label: 'Capacete', value: 'CAPACETE' },
    { label: 'Joelheira', value: 'JOELHEIRA' },
    { label: 'Cotoveleira', value: 'COTOVELEIRA' },
    { label: 'Óculos de Proteção', value: 'OCULOS_PROTECAO' },
    { label: 'Luvas Táticas', value: 'LUVAS_TATICAS' },
    { label: 'Botas Táticas', value: 'BOTAS_TATICAS' },
    { label: 'Máscara de Proteção', value: 'MASCARA_PROTECAO' },
    { label: 'Telefone Corporativo', value: 'TELEFONE_CORPORATIVO' },
    { label: 'Headset', value: 'HEADSET' },
    { label: 'Intercomunicador', value: 'INTERCOMUNICADOR' },
    { label: 'Câmera Corporal', value: 'CAMERA_CORPORAL' },
    { label: 'Câmera de Vigilância', value: 'CAMERA_VIGILANCIA' },
    { label: 'Binóculos', value: 'BINOCULOS' },
    { label: 'Monóculo', value: 'MONOCULO' },
    { label: 'Drone', value: 'DRONE' },
    { label: 'GPS', value: 'GPS' },
    { label: 'Detector de Metais', value: 'DETECTOR_METAIS' },
    { label: 'Detector de Movimento', value: 'DETECTOR_MOVIMENTO' },
    { label: 'Algemas', value: 'ALGEMAS' },
    { label: 'Apito', value: 'APITO' },
    { label: 'Bastão', value: 'BASTAO' },
    { label: 'Mochila Tática', value: 'MOCHILA_TATICA' },
    { label: 'Prancheta', value: 'PRANCHETA' },
    { label: 'Tablet', value: 'TABLET' },
    { label: 'Notebook', value: 'NOTEBOOK' },
    { label: 'Kit Primeiros Socorros', value: 'KIT_PRIMEIROS_SOCORROS' },
    { label: 'Maca Portátil', value: 'MACA_PORTATIL' },
    { label: 'Desfibrilador', value: 'DESFIBRILADOR' },
    { label: 'Farda', value: 'FARDA' },
    { label: 'Camisa', value: 'CAMISA' },
    { label: 'Calça', value: 'CALCA' },
    { label: 'Jaqueta', value: 'JAQUETA' },
    { label: 'Boné', value: 'BONE' },
    { label: 'Cinto Tático', value: 'CINTO_TATICO' },
    { label: 'Crachá', value: 'CRACHA' },
    { label: 'Leitor Biométrico', value: 'LEITOR_BIOMETRICO' },
    { label: 'Leitor QR Code', value: 'LEITOR_QR_CODE' },
    { label: 'Cartão de Acesso', value: 'CARTAO_ACESSO' },
    { label: 'Torniquete', value: 'TORNIQUETE' },
    { label: 'Impressora de Cartão', value: 'IMPRESSORA_CARTAO' },
    { label: 'Esfregona', value: 'ESFREGONA' },
    { label: 'Outro Utensílio', value: 'OUTRO' },
  ];

  get tiposEquipamentoEnum() {
    const modulo = this.filtrosForm.get('IdTipoEquipamento')?.value;
    if (modulo === 1) return this.tiposArmas;
    if (modulo === 2) return this.tiposViaturas;
    if (modulo === 3) return this.tiposUtensilios;
    return [];
  }

  ativoOptions = [
    { label: 'Todos', value: null },
    { label: 'Sim', value: true },
    { label: 'Não', value: false },
  ];

  tipoOptions = [
    { label: 'Armas', value: 1 },
    { label: 'Viaturas', value: 2 },
    { label: 'Utensílios', value: 3 },
  ];

  ngOnInit() {
    const current = this.filterSvc.currentFilters;
    
    // Tratamento seguro do valor de data inicial
    let dataAquisicaoInicial: Date | null = null;
    if (current.DataAquisicao) {
      const parsedDate = new Date(current.DataAquisicao);
      if (!isNaN(parsedDate.getTime())) {
        dataAquisicaoInicial = parsedDate;
      }
    }

    this.filtrosForm.patchValue({
      Estado: current.Estado ?? null,
      Ativo: current.Ativo ?? null,
      IdPosto: current.IdPosto ?? null,
      DataAquisicao: dataAquisicaoInicial,
      Search: current.Search ?? null,
      IdTipoEquipamento: current.IdTipoEquipamento ?? null,
      TipoEquipamentoEnum: current.TipoEquipamentoEnum ?? null,
    });

    const categoriaCtrl = this.filtrosForm.get('TipoEquipamentoEnum');
    if (current.IdTipoEquipamento) {
      categoriaCtrl?.enable();
    } else {
      categoriaCtrl?.disable();
    }

    this.filtrosForm.get('IdTipoEquipamento')?.valueChanges.subscribe((tipoId) => {
      categoriaCtrl?.patchValue(null);

      if (tipoId) {
        categoriaCtrl?.enable();
      } else {
        categoriaCtrl?.disable();
      }
    });

    this.carregarEstados();
    this.carregarPostos();
  }

  private carregarEstados(): void {
    this.enumService.getEstadoEquipamento().subscribe({
      next: (response) => {
        if (response?.data) {
          this.estadoOptions = Object.entries(response.data).map(
            ([key, label]) => ({
              label: label as string,
              value: key,
            }),
          );
        }
      },
      error: (err) => {
        console.error('Erro ao carregar estados do equipamento:', err);
      },
    });
  }

  private carregarPostos(): void {
    this.postoService.list({ pageNumber: 1, pageSize: 1000 }).subscribe({
      next: (response: any) => {
        const items = response?.data?.items ?? response?.data ?? response?.items ?? response ?? [];
        if (Array.isArray(items)) {
          this.postoOptions = items.map((posto: any) => ({
            label: posto.nome || posto.Nome || posto.designacao || posto.Designacao || `Posto #${posto.id || posto.Id}`,
            value: posto.id ?? posto.Id,
          }));
        }
      },
      error: (err) => {
        console.error('Erro ao carregar postos:', err);
      },
    });
  }

  applyFilters() {
    const val = this.filtrosForm.getRawValue();

    const dataLocal = (data: Date | string): string => {
      if (typeof data === 'string') {
        const iso = data.match(/^(\d{4}-\d{2}-\d{2})/);
        if (iso) return iso[1];
        const local = data.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
        if (local) {
          return `${local[3]}-${local[2].padStart(2, '0')}-${local[1].padStart(2, '0')}`;
        }
        data = new Date(data);
      }
      if (!(data instanceof Date) || Number.isNaN(data.getTime())) return '';
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const dia = String(data.getDate()).padStart(2, '0');
      return `${ano}-${mes}-${dia}`;
    };

    const tiposDoModulo = this.tiposEquipamentoEnum;
    const tipoEspecifico = tiposDoModulo.some((tipo) => tipo.value === val.TipoEquipamentoEnum)
      ? val.TipoEquipamentoEnum
      : null;

    const filters: EquipamentoFilters = {
      Estado: val.Estado,
      Ativo: val.Ativo,
      IdPosto: val.IdPosto,
      DataAquisicao: val.DataAquisicao
        ? dataLocal(val.DataAquisicao as Date | string)
        : null,
      Search: val.Search,
      IdTipoEquipamento: val.IdTipoEquipamento,
      TipoEquipamentoEnum: tipoEspecifico,
    };

    Object.keys(filters).forEach((k) => {
      if ((filters as any)[k] === null || (filters as any)[k] === '') {
        delete (filters as any)[k];
      }
    });

    this.filterSvc.setFilters(filters);
    this.applyFilter.emit(filters);
    this.close.emit();
  }

  clearFilters() {
    this.filtrosForm.reset({
      Estado: null,
      Ativo: null,
      IdPosto: null,
      DataAquisicao: null,
      Search: null,
      IdTipoEquipamento: null,
      TipoEquipamentoEnum: null,
    });
    this.filtrosForm.get('TipoEquipamentoEnum')?.disable();
  }
}
